module.exports = __webpack_public_path__ + "img/sr.4a3e3adf.png";